import React from 'react';
import Chart from 'react-apexcharts';

export const SearchChart = (props) => {
  const { searchHistory, purchasedList } = props;
  let categoriesCity = searchHistory.map((item) => {
    return item?._id;
  });
  let countDistinationTrip = searchHistory.map((item) => {
    return item?.count;
  });
  let countPurchasedTrip = purchasedList.map((item) => {
    return item?.count;
  });

  const options = {
      colors: ['var(--primary)', 'var(--secondary-light)'],
      markers: {
        colors: ['var(--primary)', 'var(--secondary-light)'],
      },
      stroke: {
        curve: 'smooth',
      },
      legend: {
        markers: {
          width: 15,
          height: 15,
          strokeWidth: 0,
          strokeColor: '#fff',
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0,
        },
        show: true,
        position: 'top',
        horizontalAlign: 'center',
      },
      chart: {
        id: 'chart2',
        type: 'area',
        height: 230,
        foreColor: '#ccc',
        toolbar: {
          autoSelected: 'pan',
          show: true,
        },
      },
      stroke: {
        width: 3,
      },
      grid: {
        borderColor: '#fff',
        clipMarkers: false,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        gradient: {
          enabled: true,
          opacityFrom: 0.55,
          opacityTo: 0,
        },
      },
      markers: {
        size: 5,
        colors: ['var(--primary)', 'var(--secondary-light)'],
        strokeColor: '#aaacaf',
        strokeWidth: 3,
      },
      xaxis: {
        type: 'category',
        categories: categoriesCity,
        labels: {
          show: true,
          style: {
            fontSize: '0.5rem',
          },
        },
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        show: true,
        showAlways: true,
        showForNullSeries: false,
        axisBorder: {
          show: false,
        },
      },
      grid: {
        show: true,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        style: {
          fontSize: '12px',
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          type: 'vertical',
          colorStops: [
            [
              {
                offset: 0,
                color: 'var(--primary-light)',
                opacity: 1,
              },
              {
                offset: 70,
                color: 'var(--primary-light)',
                opacity: 1,
              },
              {
                offset: 100,
                color: 'var(--primary)',
                opacity: 1,
              },
            ],
            [
              {
                offset: 0,
                color: 'var(--secondary-light)',
                opacity: 1,
              },
              {
                offset: 70,
                color: 'var(--secondary-light)',
                opacity: 1,
              },
              {
                offset: 100,
                color: 'var(--secondary-light)',
                opacity: 1,
              },
            ],
          ],
        },
      },
    },
    series = [
      {
        name: props.intl.formatMessage({
          id: 'profile.NumberFlightPurchases',
        }),
        data: countPurchasedTrip,
      },
      {
        name: props.intl.formatMessage({
          id: 'profile.NumberFlightSearches',
        }),
        data: countDistinationTrip,
      },
    ];
  return (
    <>
      <Chart
        options={options}
        series={series}
        type="line"
        width="100%"
        height="250rem"
      />
    </>
  );
};
